export const filterSmartMultiFields = (originValue: string | string[], value: string) => {
  const values = Array.isArray(originValue) ? originValue : [originValue];
  value = String(value).replace(/ /gi, '').trim();
  return values
    .reduce((acc, val) => `${acc}${val}`.toLocaleLowerCase(), '')
    .includes(String(value).toLocaleLowerCase());
};
